import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AppStateService {

  appLabelSubject = new BehaviorSubject<string | undefined> (undefined);
  appLabel$ = this.appLabelSubject.asObservable();

  backButtonSubject = new BehaviorSubject<boolean> (false);
  backButton$ = this.backButtonSubject.asObservable();

  private patientSubject = new BehaviorSubject<string | null>(null);
  patient$ = this.patientSubject.asObservable();

  // Try to remember old state if page is refreshed (not for when app is re-loaded)
  constructor() {
    const currentAppLabel = localStorage.getItem('appLabel');
    if (currentAppLabel) {
      this.appLabelSubject.next(currentAppLabel);
    }
    const isBackButtonVisible = localStorage.getItem('backButton') === 'true';
    if (isBackButtonVisible) {
      this.backButtonSubject.next(isBackButtonVisible);
    }
    const bufferedPatient =
      sessionStorage.getItem('smart_patient_buffer');

    if (bufferedPatient) {
      this.patientSubject.next(bufferedPatient);
    }
  }

  setPatient(patientId: string | null): void {
    this.patientSubject.next(patientId);

    console.log("AppState setPatient:", patientId);
  }

  // Track updating of the app label by path chosen from route or landing page
  updateAppLabel(path: string): void {
    let newAppLabel: string | undefined;
    if (path === 'cra')
      newAppLabel = "Reporting Application"
    else if (path === 'msync')
      newAppLabel = "NMDP MatchSource® Patient Import";
    else {
      newAppLabel = undefined;
      console.log("app label is now undefined")
    }
    this.appLabelSubject.next(newAppLabel);

    // Set newAppLabel as appLabel in localstorage when it updates and is undefined only.
    if (newAppLabel !== undefined) {
      localStorage.setItem('appLabel', newAppLabel);
    } else {
      localStorage.removeItem('appLabel');
    }
  }

  //Update if back button should display
  setBackButtonState(isVisible: boolean){
    this.backButtonSubject.next(isVisible);
    localStorage.setItem('backButton', isVisible.toString());
  }
}
